import React from 'react';
import { Link } from 'ui-kit';

type Props = {
  text: string;
};
// Text component that renders text while transforming
// any https urls to hyperlinks
export default function UrlText({ text }: Props) {
  const separatedText = splitTextByLink(text);
  return (
    <div>
      {separatedText.map((value, index) =>
        value.startsWith('http://') || value.startsWith('https://') ? (
          <Link key={index} href={value}>
            {value}
          </Link>
        ) : (
          value
        ),
      )}
    </div>
  );
}

// recursively splits a string by links
const splitTextByLink = (text: string): string[] => {
  if (!text.includes('https://') && !text.includes('http://')) {
    return [text];
  }
  const protocol = text.includes('https://') ? 'https://' : 'http://';
  const start = text.indexOf(protocol);
  const spaceEnd = text.indexOf(' ', start);
  const newLineEnd = text.indexOf('\n', start);

  let end = 0;
  if (spaceEnd > 0 && newLineEnd > 0) {
    end = Math.min(spaceEnd, newLineEnd);
  } else if (spaceEnd < 0 && newLineEnd < 0) {
    end = text.length;
  } else {
    end = Math.max(spaceEnd, newLineEnd);
  }
  const firstSection = text.slice(0, start);
  while (text.charAt(end - 1).match(/^[.,:;!?"']/)) {
    end--;
  }
  const linkSection = text.slice(start, end);
  const restSection = text.slice(end);
  return [firstSection, linkSection, ...splitTextByLink(restSection)];
};
